var map = {
	"./symbol_0.png": 13756,
	"./symbol_1.png": 43173,
	"./symbol_2.png": 55022,
	"./symbol_3.png": 14391,
	"./symbol_4.png": 22872,
	"./symbol_5.png": 7489,
	"./symbol_6.png": 58506,
	"./symbol_7.png": 97363,
	"./symbol_8.png": 71444,
	"./symbol_9.png": 92573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7639;